import { useContext } from "react";

import { useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";
import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const mutationFactory = () => {
  const query = `mutation removeTaskFromConditionsGroup($taskId: ID!) {
      removeTaskFromConditionsGroup(taskId: $taskId) {
        successMessage
      }
    }`;

  const resolver = ({ data: { removeTaskFromConditionsGroup } }) => {
    return { data: removeTaskFromConditionsGroup };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

export function useRemoveTaskFromConditionsGroup() {
  const mutate = useMutation(mutationFactory);
  const { fireError } = useContext(ToasterContext);

  return (taskId) => {
    return mutate({ taskId: toGlobalId("Task", taskId) })
      .then((resp) => {
        return resp;
      })
      .catch((e) => {
        fireError(
          Array.isArray(e) && e[0]?.message
            ? e[0].message
            : "Failed to removes task from conditions group, please retry or contact support for assistance",
          e
        );
      });
  };
}

export default useRemoveTaskFromConditionsGroup;
